import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"
import { format } from "date-fns";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function fmtDate(d, withTime = false) {
  if (!d) return '';
  const dt = typeof d === 'string' ? new Date(d.length === 10 ? `${d}T00:00:00` : d) : d;
  if (isNaN(dt.getTime())) return d;
  return format(dt, withTime ? 'dd-MM-yyyy, HH:mm' : 'dd-MM-yyyy');
}
